/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrgUnitReserveCancelCreatePathOrgUnitId,
	OrgUnitReserveCancelCreatePathReserveId,
	OrgUnitReserveCancelCreateStatus200,
} from "../types/OrgUnitReserveCancelCreate.ts";

function getOrgUnitReserveCancelCreateUrl(org_unit_id: OrgUnitReserveCancelCreatePathOrgUnitId, reserve_id: OrgUnitReserveCancelCreatePathReserveId) {
	const res = { method: "POST", url: `/api/org_unit/${org_unit_id}/reserve/${reserve_id}/cancel/` as const };

	return res;
}

/**
 * @summary отмена брони гостем
 * {@link /api/org_unit/:org_unit_id/reserve/:reserve_id/cancel/}
 */
export async function orgUnitReserveCancelCreate(
	org_unit_id: OrgUnitReserveCancelCreatePathOrgUnitId,
	reserve_id: OrgUnitReserveCancelCreatePathReserveId,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgUnitReserveCancelCreateStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "POST",
		url: getOrgUnitReserveCancelCreateUrl(org_unit_id, reserve_id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
